import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import Image from 'next/image';
import { Swiper, SwiperHandle } from '../Swiper';
import { ImageLink, ShowMore } from './styled';
import { Photo } from '../../graphql/graphql';
import { SwiperDirection } from '../ui/ItemCard/types';

interface ItemCarouselProps {
  photos?: Photo[];
  path?: string;
  photosCount?: number;
  scrollTo: SwiperDirection | null;
}

export const ItemCarousel: React.FC<ItemCarouselProps> = ({
  photos,
  path,
  photosCount,
  scrollTo
}) => {
  const { t } = useTranslation();
  const swiperRef = useRef<SwiperHandle | null>(null);

  useEffect(() => {
    if (scrollTo === SwiperDirection.Next) {
      swiperRef.current?.slideNext();
    } else if (scrollTo === SwiperDirection.Prev) {
      swiperRef.current?.slidePrev();
    }
  }, []);

  const photosLength = photos?.length || 0;

  return (
    <Swiper
      ref={swiperRef}
      images={photos}
      renderItem={(image, index) => {
        const hasShowMoreBtn =
          (photosCount || 0) > photosLength && index === photosLength - 1;

        return (
          <ImageLink href={path!} prefetch={false}>
            <Image fill src={image.thumbnail} alt="" />
            {hasShowMoreBtn && (
              <ShowMore>
                {t('cards.item_card.show_more', { count: photosCount })}
              </ShowMore>
            )}
          </ImageLink>
        );
      }}
    />
  );
};
